// The mispelling of CANCELLED is intentional to match against what BulkManager API returns
const BATCH_STATUS = {
  PROCESSING: "PROCESSING",
  COMPLETE: "COMPLETE",
  PARTIAL: "PARTIAL",
  UPLOAD_CANCELLED: "UPLOAD_CANCELED",
  DOWNLOAD_CANCELLED: "DOWNLOAD_CANCELED",
  ERROR: "ERROR",
  CANCELLING: "CANCELING",
  WAITING: "WAITING",
};

const BATCH_TYPE = {
  UPLOAD: "UPLOAD",
  DOWNLOAD: "DOWNLOAD",
};

const ENTITY_FILTER_OPTIONS = {
  ORGANIZATION: "Organization",
  AGENCY: "Agency",
  ADVERTISER: "Advertiser",
  CAMPAIGN: "Campaign",
  STRATEGY: "Strategy",
};

const SORTED_ENTITY_FILTERS = [
  ENTITY_FILTER_OPTIONS.ORGANIZATION,
  ENTITY_FILTER_OPTIONS.AGENCY,
  ENTITY_FILTER_OPTIONS.ADVERTISER,
  ENTITY_FILTER_OPTIONS.CAMPAIGN,
  ENTITY_FILTER_OPTIONS.STRATEGY,
];

const ENTITY_TYPE_TO_PARAM_KEYS = {
  Organization: "organization_id",
  Agency: "agency_id",
  Advertiser: "advertiser_id",
  Campaign: "campaign_id",
};

const BATCHES_PER_PAGE = 100;

export {
  BATCHES_PER_PAGE,
  BATCH_STATUS,
  BATCH_TYPE,
  SORTED_ENTITY_FILTERS,
  ENTITY_TYPE_TO_PARAM_KEYS,
};
